










import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/components/Header/Logo.vue'
import Nav from '@/components/Header/Nav.vue'
import IconeCarrinho from '@/components/Header/IconeCarrinho.vue'

@Component({
  components: {
    Logo, Nav, IconeCarrinho
  },
 
})
export default class Header extends Vue {
 
}
